import Column from '@components/Column';
import Text from '@components/Text';
import { ICON_DEFAULT_COLOR } from '@constants/icons';
import styled from '@emotion/styled';
import { IconProps } from '@models/icons';
import { pressActionEffect } from '@styles/mixin';
import { JSX } from 'react';

interface Props {
    icon: (props: IconProps) => JSX.Element,
    label: string;
    content: string;
    onClick?: () => void;
}

function UserRewardItem({
    icon: Icon, label, content, onClick,
}:Props) {
    return (
        <Container spacing={1} align='center' onClick={onClick}
            aria-label='home-reward'
            data-label={label} >
            <Icon size={24} color={ICON_DEFAULT_COLOR}/>
            <Text fontWeight='bold' align='center' ellipsis>
                {content}
            </Text>
            <Text size='body-long' color='var(--color-text-third)' align='center' ellipsis>
                {label}
            </Text>
        </Container>
    );
}

const Container = styled(Column)`
    flex: 1;
    min-width: 0;
    ${pressActionEffect}
`;

export default UserRewardItem;
